import { Bar, Size } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import IconButton from 'components/foundation/buttons/IconButton/IconButton';
import { ReactNode } from 'react';
import { ClassName } from 'types/ClassName';
import { ChevronRightIcon } from '../../../../assets/icons';
import './ProjectPickerRow.scss';

export interface IProjectPickerRowProps {
  title: ReactNode;
  size?: Size;
  className?: ClassName;
  onChevronClick?: (e: React.MouseEvent) => void;
  subprojectsSelected?: 'all' | 'some' | 'none';
}

function ProjectPickerRow({
  title,
  size = Size.SMALL,
  className,
  onChevronClick,
  subprojectsSelected = 'none',
}: IProjectPickerRowProps) {
  return (
    <Bar size={size} className={classNames('project-picker-row', 'pl-3', className)}>
      <div className="picker-row-title ellipsis">{title}</div>
      {onChevronClick && (
        <div
          className={classNames('subproject-btn', {
            'some-children-selected': subprojectsSelected === 'some',
            'all-children-selected': subprojectsSelected === 'all',
          })}
        >
          <IconButton svg={ChevronRightIcon} ripple={false} onClick={onChevronClick} />
        </div>
      )}
    </Bar>
  );
}

export default ProjectPickerRow;
